/**
 * =============================================================================
 * recently-viewed.js
 * =============================================================================
 * Manage the recently viewed section
 * 
 * Stores product handles when viewing product pages, then crafts a special URL
 * to a specific search template to get only the tiles matching those handles.
 * =============================================================================
 */

 var RecentlyViewed = {
  view: "product-tiles",

  /**
   * Initialisation
   */
  init() {
    if(MP.Utilities.isProductPage()){
      this.storeProductView();
    }
    if(document.querySelectorAll(".section-recently-viewed").length > 0){
      this.render();
    }
  },

  /**
   * Render the panel(s)
   */
  render() {
    let handles = this.getRecentlyViewed();
    let url = this.buildFetchUrl(handles);
    this.fetchTiles(url);
  },

  /**
   * Generate a fetch URL to the /search raw view (template)
   * 
   * @param {Array} handles 
   * @returns {String} URL to fetch
   */
  buildFetchUrl(handles) {
    let prefixedHandles = handles.map(e => `handle:${e}`).join("+OR+");
    return `/search?q=${prefixedHandles}&type=product&view=${this.view}`;
  },

  /**
   * Perform a fetch from the server
   * 
   * @param {String} url 
   */
  fetchTiles(url) {
    fetch(url).then(response => response.json())
      .then(response => this.onFetchedTiles(response.tiles));
  },

  /**
   * Generate tiles for the fetched products
   * 
   * @param {Array} tiles HTML tiles returned from fetch
   */
  onFetchedTiles(tiles) {
    if(tiles.length > 0){
      document.querySelectorAll(".section-recently-viewed").forEach(e => {
        let grid = e.querySelector("#rv-grid")
        grid.innerHTML = "";
        tiles.forEach(tile => {
          grid.insertAdjacentHTML('beforeend', `<div>${tile}</div>`);
        });
      });
      mp_lazyload_setup();
      this.refreshFeefoWidgets();
    } else {
      document.querySelectorAll(".section-recently-viewed").forEach(e => {
        e.parentNode.removeChild(e);
      });
    }
  },

  /**
   * Feefo widgets are only hydrated on initial library scan.
   * Recently viewed tiles are injected after initial load, so we
   * re-append the Feefo script to force widget re-initialisation.
   */
  refreshFeefoWidgets() {
    try {
      if (typeof window === 'undefined') return;
      if (window.__mp_feefo_recently_viewed_refreshed) return;
      window.__mp_feefo_recently_viewed_refreshed = true;

      const feefoSrc = 'https://api.feefo.com/api/javascript/arran-aromatics';
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = feefoSrc;
      script.async = true;
      document.body.appendChild(script);
    } catch (e) {
      console.error('[RecentlyViewed] Feefo refresh failed', e);
    }
  },

  /**
   * Get recently viewed product handles
   * 
   * @returns {Array} Handles
   */
  getRecentlyViewed() {
    return Cookies.get('rv-handles') === undefined ? [] : JSON.parse(Cookies.get('rv-handles')).filter(e => e !== "");
  },

  /**
   * Store the handle of the current product as a recently viewed product
   */
  storeProductView(){
    let recentlyViewedHandles = this.getRecentlyViewed();
    // let currentHandle = window.location.pathname.split("/").pop();
    let currentHandle = window.location.pathname.replace(/\/$/, "").split("/").pop();

    let hasProduct = false;

    // Don't add duplicates
    recentlyViewedHandles.forEach(handle => {
      hasProduct = handle == currentHandle || hasProduct;
    });

    if(!hasProduct){
      recentlyViewedHandles.push(currentHandle);
      if(recentlyViewedHandles.length > 3){
        recentlyViewedHandles.shift();
      }
    }

    Cookies.set('rv-handles', JSON.stringify(recentlyViewedHandles));
  }
}

export default RecentlyViewed; 